module.exports = __webpack_public_path__ + "static/ecotrail-7a49414e996817d74ed978de76fbb7cf.png";